// extracted by mini-css-extract-plugin
module.exports = {"button":"PaymentButton_button__1hq78","disabled":"PaymentButton_disabled__3HboG","fadeIn":"PaymentButton_fadeIn__3o_b2","fadeOut":"PaymentButton_fadeOut__2BcjR"};